import { PresentationOption } from "./../vo/presentation-option";
import { Injectable } from "@angular/core";
import { CourseContextModelService } from "../models/course-context-model.service";
import { CoursePage } from "../vo/course-page";
import { Subscription } from "rxjs";
import { CourseScene } from "../vo/course-scene";
import { DescriptorModelService } from "../models/descriptor-model.service";
import { DefinitionModelService } from "../models/definition-model.service";
import { CourseStructureModelService } from "../models/course-structure-model.service";
import { Title } from "@angular/platform-browser";
import { TrackingManager } from "../tracking/tracking-manager";
import { AppConstants } from "../vo/app-constants";
import { ConfigDocModelService } from "../models/config-doc-model.service";
import { ApplicationModel } from "../models/application.model";
import { ModalPopupService } from "app/services/modal-popup.service";

@Injectable()
export class ScreenControllerService {
	private coursePage: CoursePage;
	private isPageContinue: boolean;
	private isContinueActive: boolean = false;
	private isIagreeButtonActive: boolean = false;
	public totalPages: number = 0;
	public totalPagesInCourse: number = 0;
	public currentPage: number = 0;
	public currentPageOfTotalPagesInCourse: number = 0;
	public totalCompletedPagesInCourse: number = 0;
	private updateScreenSubscription: Subscription;
	private arrPagesToBeSkipped = [];
	constructor(
		public courseContextModel: CourseContextModelService,
		public definitionModel: DefinitionModelService,
		public courseStructureModel: CourseStructureModelService,
		public configDocModel: ConfigDocModelService,
		private pageTitle: Title,
		public descriptorModel: DescriptorModelService,
		private popupService: ModalPopupService
	) {
		this.updateScreenSubscription = this.courseContextModel.notifier.subscribe(
			(data) => {
				if (data) {
					this.updateScreen(data);
				}
			}
		);
	}

	public updateScreen(data: any): void {
		if (
			typeof data === "object" &&
			data.hasOwnProperty("coursePage") &&
			data.coursePage !== undefined
		) {
			this.coursePage = data.coursePage;
			this.totalPages = this.courseContextModel.totalPages;
			this.totalPagesInCourse = this.courseContextModel.totalPagesInCourse;
			this.currentPage = this.courseContextModel.currentPage;
			//this.currentPageOfTotalPagesInCourse = this.courseContextModel.currentPageOfTotalPagesInCourse;
			// this.currentPageOfTotalPagesInCourse = this.courseContextModel.currentPage;
			this.pageTitle.setTitle(
				data.coursePage.page_id +
					"-" +
					this.configDocModel.getCourseTitle(
						this.courseContextModel.currentLanguage
					)
			);
			TrackingManager.instance.setCurrentModuleScoreAndMaxModuleScore(
				this.courseContextModel.getPageInfoById(
					this.courseContextModel.currentPageInfo.page_id
				).module_id
			);
			TrackingManager.instance.setTotalScoreAndMaxTotalScore();
			this.updateBookMarks();
		}
	}
	private updateBookMarks() {
		let pageInfo = this.courseContextModel.getPageInfoById(
			this.coursePage.page_id
		);
		TrackingManager.instance.updateBookmark(
			pageInfo.scene_id,
			this.courseContextModel.currentPage,
			pageInfo.scene_status
		);
		TrackingManager.instance.updateLessonLocation(
			AppConstants.LANGUAGE,
			this.courseContextModel.currentLanguage
		);
		TrackingManager.instance.updateLessonLocation(
			AppConstants.PRESENTATION_MODE,
			this.courseContextModel.selectedPresentationMode.mode
		);

		TrackingManager.instance.updateLessonLocation(
			AppConstants.MODULE_ID,
			pageInfo.module_id
		);
		TrackingManager.instance.updateLessonLocation(
			AppConstants.SCENE_ID,
			pageInfo.scene_id
		);
		TrackingManager.instance.updateLessonLocation(
			AppConstants.PAGE_ID,
			this.coursePage.page_id
		);
		//TrackingManager.instance.updateLessonLocation(AppConstants.MAIN_MENU, AppConstants.MAIN_MENU);

		TrackingManager.instance.saveData(true);
	}
	public skipPage(arrPageList) {
		this.arrPagesToBeSkipped.push(arrPageList);
	}
	public exitCourse() {
		TrackingManager.instance.doFinish();
	}
	public next() {
		//this.skipPagesMarkForSkipping();
		this.courseContextModel.next();
	}

	public back() {
		//this.skipPagesMarkForSkipping();
		this.courseContextModel.back();
	}

	public skipPagesMarkForSkipping() {
		TrackingManager.instance.pagesCompletedForLMSRelaunch =
			this.coursePage.page_id;
		this.arrPagesToBeSkipped.forEach((pageID) => {
			TrackingManager.instance.skipPages = pageID;
			this.courseContextModel.markPageAsCompletedAndSkip(pageID);
		});
		this.arrPagesToBeSkipped = [];
	}

	public triggerRubricComplete(event: string): void {
		this.courseContextModel.pageComplete(event);
	}
	public set pageContinue(bool: boolean) {
		this.isPageContinue = bool;
	}
	public get pageContinue(): boolean {
		return this.isPageContinue || false;
	}
	public set activeContinue(bool: boolean) {
		this.isContinueActive = bool;
	}
	public get activeContinue(): boolean {
		return this.isContinueActive || false;
	}
	public get flagList() {
		return this.configDocModel.flagList;
	}
	public jumpToPage(pageid) {
		const pageInfo = this.courseContextModel.getPageInfoById(pageid);
		// this.courseStructureModel.updateStatusForJumpToPage(pageid);
		if(pageInfo){
		this.courseContextModel.updateCoursePageByIndex(
			pageid,
			pageInfo.module_index,
			pageInfo.scene_index,
			pageInfo.page_index
		);
		}
	}
	public get isNext(): boolean {
		return true;
	}
	public get pageComplete(): boolean {
		return (
			this.coursePageVal &&
			this.coursePageVal.status === "c" &&
			!this.courseContextModel.courseLastPage()
		);
	}
	public get audioOn(): boolean {
		return this.courseContextModel.audioOn;
	}

	public get showDoc(): boolean {
		return this.courseContextModel.customDoc != null;
	}
	public get isGlossary(): boolean {
		return (
			this.courseContextModel.customDoc.iconTarget.indexOf("glossary.swf") !==
			-1
		);
	}

	public closeCustomDoc() {
		this.courseContextModel.customDocs.forEach((item) => {
			item.isVisible = false;
		});
		ApplicationModel.instance.videoOverlay = false;
		this.courseContextModel.customDoc = null;
		var Inneriframe: any = window.document.getElementById("ifrm_hyperlink");
		if (Inneriframe) {
			Inneriframe.src = Inneriframe.src;
		}
	}
	public closeModelPopup() {
		try {
			this.popupService.closePopup();
			this.popupService.closeDialogPopup();
		} catch (e) {}
	}
	public get documentContent(): string {
		return this.showDoc
			? this.courseContextModel.customDoc.iconTarget.replace(".swf", ".html")
			: "";
	}

	public get isPrintable(): boolean {
		return this.courseContextModel.customDoc.isPrintable;
	}

	public get coursePageVal(): CoursePage {
		return this.coursePage;
	}

	public get selectedPresentationMode(): PresentationOption {
		return this.courseContextModel.selectedPresentationMode;
	}

	public get courseStructureModelDocs(): any {
		return this.courseContextModel.getCurrentDocs();
	}

	public set activateIagreeButton(val: boolean) {
		this.isIagreeButtonActive = val;
	}
	public get activateIagreeButton() {
		return this.isIagreeButtonActive;
	}
}
